import React from "react";
import { Label } from "semantic-ui-react";

type DDIClassificationProps = {
  classification: string;
};
const DDIClassification = ({ classification }: DDIClassificationProps) => {
  switch (classification.toLowerCase()) {
    case "standard":
      return (
        <Label as='a' color='yellow'>
          Standard
        </Label>
      );
    case "silver":
      return (
        <Label as='a' color='grey'>
          Standard
        </Label>
      );
    case "gold":
      return (
        <Label as='a' color='orange'>
          Standard
        </Label>
      );
    case "international":
      return (
        <Label as='a' color='blue'>
          International
        </Label>
      );
  }
  throw new Error("Unknown classification of ddi " + classification);
};

export default DDIClassification;
